module.exports = __webpack_public_path__ + "static/media/left.dc880f17.svg";